module.exports = __webpack_public_path__ + "mail.svg?1656660ecf3be00612673fb88de4c902";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SocialNetworks/mail.svg
// module id = 77
// module chunks = 0